"use strict";

var debug = require("debug")("knack.formatter.formatters.paymentProcessor");
var _ = require("lodash");

/**
 * @alias "formatters.paymentProcessor"
 * @param {String} paymentProcessor
 * @param {String} [paymentProcessor.processor] 'stripe', 'paypal' (default)
 * @param {String} [paymentProcessor.private_auth_key]
 * @param {String} [paymentProcessor.test_private_auth_key]
 * @param {String} [paymentProcessor.password]
 * @param {String} [paymentProcesosr.signature]
 * @param {String} [paymentProcesosr.test_signature]
 * @return {String}
 */
var paymentProcessorFormatter = function paymentProcessorFormatter(paymentProcessor) {
  switch (paymentProcessor.processor) {
    case "stripe":
      if (!_.isNil(paymentProcessor.private_auth_key)) {
        var privateAuthKey = paymentProcessor.private_auth_key.slice(-4);
        paymentProcessor.private_auth_key = "*********".concat(privateAuthKey);
      }
      if (!_.isNil(paymentProcessor.test_private_auth_key)) {
        var testPrivateKeyAuth = paymentProcessor.test_private_auth_key.slice(-4);
        paymentProcessor.test_private_auth_key = "*********".concat(testPrivateKeyAuth);
      }
      break;
    case "paypal":
    default:
      if (!_.isNil(paymentProcessor.password)) {
        paymentProcessor.password = "*********";
      }
      if (!_.isNil(paymentProcessor.signature)) {
        var signature = paymentProcessor.signature.slice(-4);
        paymentProcessor.signature = "*********".concat(signature);
      }
      if (!_.isNil(paymentProcessor.test_password)) {
        paymentProcessor.test_password = "*********";
      }
      if (!_.isNil(paymentProcessor.test_signature)) {
        var testSignature = paymentProcessor.test_signature.slice(-4);
        paymentProcessor.test_signature = "*********".concat(testSignature);
      }
      break;
  }
  return paymentProcessor;
};
module.exports = paymentProcessorFormatter;